module.exports = __webpack_public_path__ + "assets/img/index-project2-2.74cf02bd.jpg";